import clsx from "clsx";

interface ShimmerProps {
  width?: string;
  height: string;
  borderRadius?: string;
  className?: string;
}

export const Shimmer = ({
  width,
  height,
  borderRadius,
  className,
}: ShimmerProps) => {
  return (
    <div
      data-testid="shimmer"
      className={clsx(
        "bg-gray-200 animate-pulse",
        "relative overflow-hidden",
        'before:content-[""] before:absolute before:top-0 before:left-0 before:w-full before:h-full before:bg-gradient-to-r before:from-transparent dark:before:via-[#4c4e5a] before:via-white before:to-transparent before:animate-shimmer',
        className,
      )}
      style={{
        minWidth: width ?? "100%",
        maxWidth: width,
        height: height ?? "100px",
        borderRadius: borderRadius ?? "4px",
      }}
    />
  );
};
